import './Card.scss';

function Card({
  children,
  variant,
  className = '',
  ...rest
}) {
  const classes = [
    'card',
    variant ? `card--${variant}` : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}

// Sub-components for structured content
Card.Header = function CardHeader({ children, className = '', ...rest }) {
  return <div className={`card__header ${className}`} {...rest}>{children}</div>;
};

Card.Title = function CardTitle({ children, as: Tag = 'h3', className = '', ...rest }) {
  return <Tag className={`card__title ${className}`} {...rest}>{children}</Tag>;
};

Card.Subtitle = function CardSubtitle({ children, className = '', ...rest }) {
  return <p className={`card__subtitle ${className}`} {...rest}>{children}</p>;
};

Card.Body = function CardBody({ children, className = '', ...rest }) {
  return <div className={`card__body ${className}`} {...rest}>{children}</div>;
};

Card.Footer = function CardFooter({ children, className = '', ...rest }) {
  return <div className={`card__footer ${className}`} {...rest}>{children}</div>;
};

export default Card;
